import { isNil } from "@etudescarre/utils";
import { toaster } from "@/app";
import { apiClient } from "@/lib/api/client";

/** Downloads a report response: it has no PDF, its export is a CSV. */
export async function downloadReportResponse(
  yardId: string,
  responseId: number,
) {
  try {
    const { data, error } = await apiClient.GET(
      "/api/yards/{yardId}/report-responses/{responseId}/download",
      {
        params: { path: { yardId, responseId } },
        parseAs: "blob",
      },
    );
    if (error || isNil(data)) {
      toaster.error({
        title: "Erreur",
        description: "Échec du téléchargement",
      });
      return;
    }
    const url = URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `reponse-rapport-${responseId}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  } catch {
    toaster.error({
      title: "Erreur",
      description: "Échec du téléchargement",
    });
  }
}
